import React from 'react';

/**
 * Full-page maintenance notice shown when the API reports maintenance mode
 * (503 + { maintenance: true }). Rendered by App in response to the global
 * `srs:maintenance` event dispatched from api.ts.
 */
export default function MaintenanceScreen({ message }: { message?: string }) {
  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', padding: '24px',
        background: 'var(--srs-primary)', color: 'var(--srs-background)',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      }}
    >
      <div style={{ fontSize: 56, marginBottom: 16 }} role="img" aria-label="maintenance">🛠️</div>
      <h1 style={{ fontSize: 28, fontWeight: 700, margin: '0 0 12px' }}>We&rsquo;ll be right back</h1>
      <p style={{ maxWidth: 520, fontSize: 16, lineHeight: 1.6, color: 'rgba(255,255,255,0.85)', margin: 0 }}>
        {message || 'SureRightStay is currently undergoing scheduled maintenance. Please check back shortly.'}
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: 28, padding: '10px 24px', fontSize: 15, fontWeight: 600,
          color: 'var(--srs-primary)', background: 'var(--srs-primary)', border: 'none', borderRadius: 8, cursor: 'pointer',
        }}
      >
        Retry
      </button>
    </div>
  );
}
